import { Button, Icon, Notice } from "../../../../components/design";
import useTranslator from "../../../../hooks/useTranslator";
import styles from "./ExistingVerificationScreen.module.css";

interface ExistingVerificationScreenProps {
  isCompleted: boolean;
  onContinue: () => void;
  onVerifyAgain: () => void;
}

const ExistingVerificationScreen = ({
  isCompleted,
  onContinue,
  onVerifyAgain,
}: ExistingVerificationScreenProps) => {
  const { _t } = useTranslator();

  return (
    <section className={styles.screen} aria-labelledby="existing-kyc-title">
      <div className={styles.icon} aria-hidden="true">
        <Icon name="checkCircle" size={32} />
      </div>
      <div className={styles.copy}>
        <h3 id="existing-kyc-title">
          {_t(isCompleted ? "kycAlreadyVerifiedTitle" : "kycPreviousIdTitle")}
        </h3>
        <p>{_t("kycReuseExplanation")}</p>
      </div>
      <Notice>{_t("kycVerifyAgainExplanation")}</Notice>
      <div className={styles.actions}>
        <Button size="lg" block wrap onClick={onContinue}>
          {_t("kycContinueWithPreviousVerification")}
        </Button>
        <Button
          size="lg"
          block
          wrap
          variant="outline"
          iconStart={<Icon name="refresh" />}
          onClick={onVerifyAgain}
        >
          {_t("kycVerifyMyIdentityAgain")}
        </Button>
      </div>
    </section>
  );
};

export default ExistingVerificationScreen;
